import React, { useContext, useEffect } from 'react';
import { ORDERS_PER_DAY, RUN_TEST_NOW, SCHEDULE_INFO, SESSION_PER_DAY } from '../../utils/Constants';
import TestConfiguration from './TestConfiguration';
import PromotionPreference from './PromotionPreference'; // Import the PromotionPreference component
import { TPayload } from '../../types/ab';
import { ABContext } from '../../contexts/ABContext';
import { runABTest } from '../../services/ABServices';
import { toast } from 'Components/DesignSystem/Toast/useToast';
import { areObjectsIdentical } from 'Pages/GMS/ISR/Components/RuleComponents/helper';
import { useNavigate } from "react-router";
import DisplayBox from '../../components/DisplayBox';
import Button from 'Components/DesignSystem/Button/Button';
import Typography from 'Components/DesignSystem/Typography/Typography';

type ScheduleSectionProps = {
    testId: string;
    onSave: () => Promise<boolean | undefined>
}

const ScheduleSection = ({ testId, onSave }: ScheduleSectionProps) => {
    const abContext = useContext(ABContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (abContext?.setPayload) {
            abContext.setPayload((prevPayload: TPayload) => ({
                ...prevPayload,
                estimated_orders_per_day: prevPayload?.estimated_orders_per_day,
                estimated_sessions_per_day: prevPayload?.estimated_sessions_per_day,
                test_duration: prevPayload?.test_duration
            }));
        }
    }, []);

    const handleRunAbTestClick = async () => {
        let updatedPayload = {...abContext?.payload}

        if (abContext?.payload?.win_threshold === undefined) {
            updatedPayload = { ...abContext?.payload, win_threshold: 0 }
        }

        if (!areObjectsIdentical(updatedPayload, abContext?.payloadNetworkCopy)) {
            const saved = await onSave();
            if (!saved) return;
        }
        let res = await runABTest(testId)
        if (res?.done) {
            toast.info(res?.message)
            navigate("/gms/ab", { replace: true })
        } else {
            toast.error(res?.message)
        }
    }

    if (!abContext?.payload?.estimated_orders_per_day) {
        return null;
    }

    return (
        <section>
            <Typography variant="title" as="p" className="tw-text-ink-tertiary tw-mt-4">
                {SCHEDULE_INFO}
            </Typography>
            <div className='tw-flex tw-flex-wrap tw-items-center tw-gap-4 tw-mt-4'>
                <DisplayBox data-testid="detail-sessions-per-day" displayText={SESSION_PER_DAY} value={abContext?.payload.estimated_sessions_per_day?.toString() ?? "NA"} />
                <DisplayBox data-testid="detail-orders-per-day" displayText={ORDERS_PER_DAY} value={abContext?.payload.estimated_orders_per_day?.toString() ?? "NA"} />
                {/* <DisplayBox showChip={true} displayText={TEST_DURATION} value={abContext?.payload.test_duration ? `${Math.ceil(abContext?.payload?.test_duration)} Days` : "NA"} /> */}
            </div>
            <div className='tw-mt-4'><TestConfiguration /></div>
            
            
            <div className='tw-mt-6'>
                <PromotionPreference />
            </div>
            
            <div className='tw-flex tw-items-center tw-gap-3 tw-mt-8'>
                {/* <button className='outline-button'>{SCHEDULE}</button> */}
                {/*
                  The gate is unchanged: `test_duration === 0` disables Run Test Now,
                  which is what `InputboxLabel`'s "should be greater than 0" toast is
                  advising about. What changes is that a disabled DS Button reads as
                  disabled — `.button-style:disabled` in `main.css` is a lighter blue
                  that still looks like an available primary action (§ 134).
                */}
                <Button
                    variant="primary"
                    data-testid="detail-schedulesection-button-1"
                    disabled={abContext.payload?.test_duration === 0}
                    onClick={handleRunAbTestClick}
                >
                    {RUN_TEST_NOW}
                </Button>
            </div>
        </section>
    );
}

export default ScheduleSection;